module.exports = __webpack_public_path__ + "static/Portrait-RegularItalic-7a520339ae2d3ef1dffe49e411d4b041.woff";